import { CvpLocale } from "../constants/CvpLocale";
import { LocContext } from "./LocContext";

export async function getSourceMap(
  stringContext: LocContext,
  locale: CvpLocale
): Promise<{ [key: string]: any }> {
  if (locale !== CvpLocale.nb) {
    throw new Error(
      `No sources for context/locale: ${stringContext}/${locale}`
    );
  }

  if (stringContext === LocContext.ADMIN) {
    return (await import("./sources/nb/admin")).default;
  }

  if (stringContext === LocContext.CV) {
    return (await import("./sources/nb/cv")).default;
  }

  if (stringContext === LocContext.GENERAL) {
    return (await import("./sources/nb/general")).default;
  }

  if (stringContext === LocContext.JOB) {
    return (await import("./sources/nb/job")).default;
  }

  if (stringContext === LocContext.JOBS) {
    return (await import("./sources/nb/jobs")).default;
  }

  if (stringContext === LocContext.PROFILE) {
    return (await import("./sources/nb/profile")).default;
  }

  if (stringContext === LocContext.WORKSCHEDULE) {
    return (await import("./sources/nb/workschedule")).default;
  }
  if (stringContext === LocContext.TIMESHEETS) {
    return (await import("./sources/nb/timesheets")).default;
  }
  if (stringContext === LocContext.MESSAGES) {
    return (await import("./sources/nb/messages")).default;
  }

  if (stringContext === LocContext.PRIME) {
    return (await import("./sources/nb/prime")).default;
  }

  if (stringContext === LocContext.PRIVACY) {
    return (await import("./sources/nb/privacy")).default;
  }

  if (stringContext === LocContext.ERROR) {
    return (await import("./sources/nb/error")).default;
  }

  if (stringContext === LocContext.TYPES) {
    return (await import("./sources/nb/types")).default;
  }

  if (stringContext === LocContext["[Translations no longer in use]"]) {
    return {};
  }

  throw new Error(`Unhandled context/locale: ${stringContext}/${locale}`);
}
